import { RouteConfig } from "vue-router";
import MyProfile from "@/views/my/Profile.vue";
import MyCertificatesIndex from "@/views/my/certificates/Index.vue";
import MyCertificatesEdit from "@/views/my/certificates/Edit.vue";

export const myRoutes: Array<RouteConfig> = [
  {
    path: "profile",
    component: MyProfile,
    meta: {
      prefix: "/my"
    }
  },
  {
    path: "certificates",
    component: MyCertificatesIndex,
    meta: {
      prefix: "/my"
    }
  },
  {
    path: "certificates/:fingerprint/edit",
    component: MyCertificatesEdit,
    meta: {
      prefix: "/my"
    }
  },
  {
    path: "",
    redirect: "/my/profile"
  }
];
